import React, { useState } from 'react';
import { Drawer, Button, Grid, Typography, Divider, theme } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;
const { useBreakpoint } = Grid;
const { useToken } = theme;

interface HelpSection {
  title: string;
  content: string;
  tips?: string[];
}

interface PageHelpProps {
  title: string;
  sections: HelpSection[];
}

const PageHelp: React.FC<PageHelpProps> = ({ title, sections }) => {
  const [open, setOpen] = useState(false);
  const screens = useBreakpoint();
  const { token } = useToken();

  // On small screens, use a bottom drawer that takes most of the viewport.
  // On md+ screens, use a right-side drawer with a comfortable reading width.
  const isMobile = !screens.md;
  const drawerProps = isMobile
    ? { placement: 'bottom' as const, height: '85vh' }
    : { placement: 'right' as const, width: 400 };

  return (
    <>
      <Button
        type="text"
        icon={<QuestionCircleOutlined />}
        onClick={() => setOpen(true)}
        size="small"
        style={{ color: token.colorTextSecondary }}
        aria-label={`Open help for ${title}`}
      />
      <Drawer title={title} onClose={() => setOpen(false)} open={open} {...drawerProps}>
        {sections.map((section, i) => (
          <div key={section.title}>
            {i > 0 && <Divider />}
            <Title level={5}>{section.title}</Title>
            <Paragraph style={{ whiteSpace: 'pre-line' }}>{section.content}</Paragraph>
            {section.tips && section.tips.length > 0 && (
              <div
                style={{
                  background: token.colorInfoBg,
                  border: `1px solid ${token.colorInfoBorder}`,
                  borderRadius: 6,
                  padding: '8px 12px',
                  marginTop: 8,
                }}
              >
                <Text strong style={{ fontSize: 12, color: token.colorInfo }}>
                  Tips
                </Text>
                <ul style={{ margin: '4px 0 0', paddingLeft: 16, fontSize: 13 }}>
                  {section.tips.map((tip, j) => (
                    <li key={j} style={{ marginBottom: 2 }}>
                      {tip}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </Drawer>
    </>
  );
};

export default PageHelp;
